export const bookingStatusTextNotVerified = (status: any) => {
  switch (status) {
    case 'Предварительное бронирование':
      return 'Бронирование принято, в ближайшее время с Вами свяжется менеджер для подтверждения брони.';
    case 'Предварительное бронирование ночное':
      return 'Бронирование принято, менеджер свяжется с Вами утром для подтверждения брони.';
    default:
      return 'Бронирование принято, в ближайшее время с Вами свяжется менеджер для подтверждения брони.';
  }
};

export const bookingStatusTextVerified = (stageId: any) => {
  switch (stageId) {
    case 'PREPAYMENT_INVOICE':
    case '15':
    case '12':
      return 'Заявка подана';
    case '13':
      return 'Забронировано';
    case '16':
      return 'Готова к Вашему заезду';
    case '14':
      return 'Полностью оплачено';
    default:
      return 'Заявка подана';
  }
};

export const bookingStatusPayment = (stageId: any) => {
  switch (stageId) {
    case 'Бронирование':
    case 'Предварительное бронирование':
      return 'заезд';
    case 'Внесена предоплата':
      return 'внесена предоплата';
    case 'Полная оплата':
      return 'полная оплата';
    default:
      return 'заезд';
  }
};
